import React from 'react';
import styled from 'styled-components';
import AllPackages from '../user/packages/AllPackages';


const OurPricing = () => {

    return (

        <StyledPricing>
            <div className="pricing" id='pricing'>
                <div className="container">
                    <div className=" text-center">
                        <h3 className="pry-text">
                            Pricing plan
                        </h3>
                    </div>

                    <AllPackages />

                </div>
            </div>
        </StyledPricing>
    );
};

export default OurPricing;


const StyledPricing = styled.div`
    
padding: 5rem 0;

`;